import {UpOutlined} from '@ant-design/icons';
import {useEffect, useState} from 'react';
import {useLocation} from 'react-router-dom';

const ScrollToTop = () => {
  const [visible, setVisible] = useState(false);
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }, [pathname]);

  useEffect(() => {
    const toggleVisibility = () => {
      setVisible(window.scrollY > 200);
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    visible && (
      <button
        onClick={scrollToTop}
        className={'fixed bottom-6 right-6 bg-primary-700 text-white px-3 py-2 rounded-full shadow-lg hover:bg-primary-800 transition'}
      >
        <UpOutlined className={'font-semibold text-lg'} />
      </button>
    )
  );
};

export default ScrollToTop;
